export const iconFontAwesomeMapsGlobe = (
	<i className="fa-solid fa-globe"></i>
);
